type CustomErrorType = 'UNKNOWN' |
    'SESSION_EXPIRED' |
    'SESSION_INVALID' |
    'VOUCHER_TYPE_NOT_FOUND' |
    'VOUCHER_TYPE_BLOCKED' |
    'TEMPLATE_NOT_FOUND' |
    'TEMPLATE_BLOCKED' |
    'VOUCHER_TYPE_NOT_LINKED' |
	'VOUCHER_TYPE_LIMIT_ZERO' |
	'DISTRIBUTION_FULL_QUOTA' |
	'DISTRIBUTION_INSUFFICIENT_REMAINING_QUOTA' |
	'DISTRIBUTION_BATCH_BALANCE_OUT_OF_RANGE' |
    'RECIPIENT_LIMIT_AMOUNT_REACHED' |
    'VOUCHERS_UNAVAILABLE';

type CustomError = {
    message: string;
    type: CustomErrorType;
    parameters?: object[];
};

const parseToCustomError = (data?: unknown): CustomError | null => {
    if (!data)
        return null;

    const { message, type, ...rest } = data as {
        message?: string;
        type?: CustomErrorType;
    };

    if (!message || !type)
        return null;

    return {
        message,
        type,
        ...rest
    };
};

export type { CustomError };
export { parseToCustomError };